module.exports = __webpack_public_path__ + "img/35_10.d7311e6f.png";